import { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { CtaBand } from "@/components/site/PageHero";
import { CategoryHero } from "@/components/catalog/CategoryHero";
import { CategoryFaqs, FactsBar, RelatedCategories, WhereUsed } from "@/components/catalog/CategorySections";
import { ProductCard, ProductRow } from "@/components/catalog/ProductParts";
import { CATEGORIES } from "@/data/products";
import { categoryJsonLd, categorySummary, categoryTitle } from "@/data/seo";
import { SITE_URL, useSeo } from "@/lib/seo";

const CategorySeo = ({ c }) => {
  useSeo({ title: categoryTitle(c), description: categorySummary(c), path: `/solutions/${c.slug}`, image: c.products[0].image, jsonLd: categoryJsonLd(SITE_URL, c) });
  return null;
};

export default function CategoryPage() {
  const { slug } = useParams();
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.getElementById(hash.slice(1));
      if (!el) return;
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("ring-2", "ring-[#C20500]");
      setTimeout(() => el.classList.remove("ring-2", "ring-[#C20500]"), 2200);
    }, 350);
    return () => clearTimeout(t);
  }, [hash, slug]);
  const index = CATEGORIES.findIndex((x) => x.slug === slug);
  if (index < 0) return <Navigate to="/solutions" replace />;
  const c = CATEGORIES[index];
  const list = c.layout === "list";
  return (
    <div data-testid={`category-page-${c.slug}`}>
      <CategorySeo c={c} />
      <CategoryHero c={c} index={index} />
      <FactsBar c={c} />
      <section id="products" className="container-x scroll-mt-20 py-20" data-testid="category-products">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="eyebrow" style={{ color: c.accent }}>Product range</p>
            <h2 className="mt-3 text-2xl text-slate-900 sm:text-3xl">{c.products.length} product lines</h2>
          </div>
          <p className="max-w-md text-sm text-slate-500">Tap "Get a quote" on any product. A specialist replies with pricing within 1 business day.</p>
        </div>
        <div className={`mt-10 ${list ? "space-y-5" : "grid gap-5 sm:grid-cols-2 lg:grid-cols-3"}`}>
          {c.products.map((p, i) => (list ? <ProductRow key={p.id} p={p} index={i} /> : <ProductCard key={p.id} p={p} />))}
        </div>
      </section>
      <WhereUsed c={c} />
      <CategoryFaqs faqs={c.faqs} />
      <RelatedCategories current={c} />
      <CtaBand />
    </div>
  );
}
